import axios from '../../api/instance';
import deepcopy from 'clone-deep';
import {defaultFormatUtc} from 'moment';

const namespace = 'proposal_progress/';


const SET_INSTALLATION_PLACED = namespace + 'set_installation_placed';
const SET_INSTALLATION_PROGRESS = namespace + 'set_installation_progress';

export const GET_APPOINTMENT = namespace + 'get_appointment';
export const SET_APPOINTMENT = namespace + 'set_appointment';
export const RESET_APPOINTMENT = namespace + 'reset_appointment';

export const FETCH_INSTALLATION_PROGRESS = namespace + 'fetch_installation_progress';

export const GET_INSTALLATION_PLACED = namespace + 'installation_placed';
export const GET_INSTALLATION_PROGRESS = namespace + 'installation_progress';
export const CLEAR_INSTALLATION_PROGRESS_DATA = namespace + 'clear_installation_data';
export const ADD_INSTALLATION_PLACED = namespace + 'installation_placed';
export const ADD_PROGRESS = namespace + 'add_progress';

const INSTALLATION_PLACED_KEY = 'INSTALLATION_PLACED';

export default {
    state: {
        installation_placed: localStorage.getItem(INSTALLATION_PLACED_KEY),
        installation_progress: {
            requested: {
                completed: false,
                date: null,
            },
            signed: {
                completed: false,
                date: null,
            },
            called: {
                completed: false,
                date: null,
            },
            install: {
                completed: false,
                date: null,
                slot: 'morning',
            },
        },
        appointment: {
            // The list of dates and slots when the client is able to receive Minimax team for install
            moments: {
                ['2018-01-01']: ['morning'],
            },
            address: {
                street: '',// Burgemeester Baron Voorstweg
                number: '',// 45a
                postalCode: '',// 8561 GH
                city: '',// Heist-op-den-Berg
                country: '',// Nederland
            },
            comment: '',
        },
    },
    mutations: {
        [SET_INSTALLATION_PROGRESS]: (state,installation_progress)=>{
            state.installation_progress = installation_progress;
        },
        [SET_INSTALLATION_PLACED]: (state, installation_placed)=>{
            state.installation_placed = installation_placed;
            localStorage.setItem(INSTALLATION_PLACED_KEY, installation_placed);
        },
        [SET_APPOINTMENT]: (state, value) => {
            state.appointment = deepcopy(value);
        },
        [RESET_APPOINTMENT]: (state) => {
            state.appointment = {
                moments: {},
                address: {
                    street: '',
                    number: '',
                    postalCode: '',
                    city: '',
                    country: '',
                },
                comment: '',
            };
        },
    },
    actions: {
        [FETCH_INSTALLATION_PROGRESS] ({dispatch}) {
            return axios.get('proposals/api/proposals')
                .then(response => {
                    let installation_placed = response.installation_placed;
                    let installation_process = response.installation_process;
                    dispatch(ADD_PROGRESS, installation_process);
                    dispatch(ADD_INSTALLATION_PLACED, installation_placed);
                });
        },
        [ADD_INSTALLATION_PLACED]: ({commit}, installation_placed)=>{
            if (installation_placed) {
                commit(SET_INSTALLATION_PLACED, true);
            } else {
                commit(SET_INSTALLATION_PLACED, false);
            }
        },
        [ADD_PROGRESS]: ({commit}, installation_process)=>{
            let installation_progress = installation_process;

            let installationProgress = {
                requested: {
                    completed: false,
                    date: null,
                },
                signed: {
                    completed: false,
                    date: null,
                },
                called: {
                    completed: false,
                    date: null,
                },
                install: {
                    completed: false,
                    date: null,
                },
            };

            if (installation_progress.date_signed){
                installationProgress.signed.completed = true;
                installationProgress.signed.date = installation_progress.date_signed;
            }
            if (installation_progress.date_requested){
                installationProgress.requested.completed = true;
                installationProgress.requested.date = installation_progress.date_requested;
            }
            if (installation_progress.date_called){
                installationProgress.called.completed = true;
                installationProgress.called.date = installation_progress.date_called;
            }
            if (installation_progress.installation_date){
                installationProgress.install.completed = true;
                installationProgress.install.date = installation_progress.installation_date;
            }
            commit(SET_INSTALLATION_PROGRESS, installationProgress);
            return Promise.resolve();
        },
        [CLEAR_INSTALLATION_PROGRESS_DATA](commit){
            commit(SET_INSTALLATION_PLACED, null);
            commit(SET_INSTALLATION_PROGRESS, {});
            localStorage.setItem(INSTALLATION_PLACED_KEY, null);
        },
        // [SUBMIT_CHANGE_REQUEST]: ({commit}, appointment) => {
        //     return axios.put('proposal/appointment', appointment)
        //         .then(response => {
        //             const state = response.data;
        //             commit(SET_PROGRESS, state.progress);
        //             commit(SET_APPOINTMENT, state.appointment);
        //         });
        // },
    },
    getters: {
        [GET_APPOINTMENT]: (state) => deepcopy(state.appointment),
        [GET_INSTALLATION_PROGRESS]: (state) => deepcopy(state.installation_progress),
        [GET_INSTALLATION_PLACED](state){
            return state.installation_placed === true || state.installation_placed == 'true';
        }
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/proposal_progress.js